import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserTableComponent } from './components/user-table/user-table.component'
import { UserRoutingModule } from './importAndExportData-routing.module'
import { DataTablesModule } from 'angular-datatables';
import { KamRegionComponent } from './components/kam-region/kam-region.component';
import { LogTableComponent } from './components/log-table/log-table.component';
import { KamCustomersComponent } from './components/kam-customers/kam-customers.component';
import { RaitingDistributorComponent } from './components/raiting-distributor/raiting-distributor.component';
import { DistributorAgreementComponent } from './components/distributor-agreement/distributor-agreement.component';
import { GoodPriceComponent } from './components/good-price/good-price.component';
import { FileImportExportService } from './service/file-import-export.service';
import { LoadImportExportService } from './service/load-import-export.service';
import { InnDependencyComponent } from './components/inn-dependency/inn-dependency.component';
import { SolocodeMappingComponent } from './components/solocode-mapping/solocode-mapping.component';

@NgModule({
  providers: [
    FileImportExportService,
    LoadImportExportService
  ],
  imports: [
    UserRoutingModule,
    CommonModule,
    DataTablesModule,
    FormsModule,
    TableModule,
    NgxSpinnerModule
  ],
  declarations: [
    UserTableComponent,
    KamRegionComponent,
    LogTableComponent,
    KamCustomersComponent,
    RaitingDistributorComponent,
    DistributorAgreementComponent,
    GoodPriceComponent,
    InnDependencyComponent,
    SolocodeMappingComponent]
})
export class ImportAndExportDataModule { }



// WEBPACK FOOTER //
// ./src/app/modules/user/importAndExportData.module.ts